"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isArray = exports.isObject = exports.isBoolean = exports.isInteger = exports.isNumber = exports.isString = void 0;
function isString(x) {
    return Object.prototype.toString.call(x) === "[object String]";
}
exports.isString = isString;
function isNumber(x) {
    if (typeof x === 'number' && !Number.isNaN(x))
        return true;
    if (typeof x === 'string') {
        const num = Number(x);
        return !Number.isNaN(num);
    }
    return false;
}
exports.isNumber = isNumber;
function isInteger(x) {
    if (typeof x === 'number' && Number.isInteger(x))
        return true;
    if (typeof x === 'string') {
        const num = Number(x);
        return !Number.isNaN(num) && Number.isInteger(num);
    }
    return false;
}
exports.isInteger = isInteger;
function isBoolean(x) {
    return typeof x === 'boolean';
}
exports.isBoolean = isBoolean;
function isObject(x) {
    return Object.prototype.toString.call(x) === '[object Object]';
}
exports.isObject = isObject;
function isArray(x) {
    return Array.isArray(x);
}
exports.isArray = isArray;
